import {useEffect, useRef} from 'react';

export const useEffectWithDeps = <T>(callback: (prev: T, current: T) => void, current: T) => {
    const ref = useRef<T>(current);

    useEffect(() => {
        callback(ref.current, current);
        ref.current = current;
    }, [current, callback]);
};
